import { AfterViewInit, Component, Injector, Input, OnInit, ViewChild } from '@angular/core';
import { FileUpload } from 'tn-custom-primeng/fileupload';
import { AppListService, ColumnSchemaBase, ComponentContextService, CrudListComponent, DataListBase, Filter, GridInfo, ModelSchema, Operator, PopupSize, TemplateInstanceService as SharedTemplateInstanceService } from 'tnx-shared';
import { dicTemplateType, TemplateTypes } from 'tnx-admin-service/templateinstance/models';
import { TemplateInstanceService } from 'tnx-admin-service/templateinstance/services';

@Component({
    selector: 'templateinstance',
    templateUrl: './templateinstance.component.html',
    styleUrls: ['./templateinstance.component.scss'],
    providers: [ComponentContextService],
})
export class TemplateInstanceComponent extends DataListBase implements OnInit, AfterViewInit {
    @ViewChild('file') file: FileUpload;

    @Input() templateType: TemplateTypes = TemplateTypes.cxExcel;
    @Input() testing: boolean = false;
    @Input() appCode: string;

    templateTypeText = dicTemplateType.get(TemplateTypes.cxExcel);

    searchSchema: any = {};
    searchData: any = {};

    constructor(
        protected _injector: Injector,
        protected _templateInstanceService: TemplateInstanceService,
        protected _sharedTemplateInstanceService: SharedTemplateInstanceService,
        private _appListService: AppListService
    ) {
        super(_injector);
    }

    ngOnInit() {
        this.setting.baseService = this._templateInstanceService;
        this.setting.modelSchemas = [
            new ModelSchema({ field: 'name', name: 'Biểu mẫu', fullName: 'Biểu mẫu', description: 'Biểu mẫu' }),
            new ModelSchema({ field: 'code', name: 'Mã', fullName: 'Mã', description: 'Mã' }),
            new ModelSchema({ field: 'description', name: 'Mô tả', fullName: 'Mô tả', description: 'Mô tả' }),
            new ModelSchema({ field: 'appCode', name: 'Phân hệ', fullName: 'Phân hệ', description: 'Phân hệ' })
        ];

        this.setting.cols = [
            new ColumnSchemaBase({ field: 'name' }),
            new ColumnSchemaBase({ field: 'code' }),
            new ColumnSchemaBase({ field: 'description' }),
            new ColumnSchemaBase({ field: 'appCode', baseService: this._appListService, displayField: 'title', valueField: 'code', hidden: this.appCode != null })
        ];

        this.setting.objectName = dicTemplateType.get(this.templateType);
        this.setting.popupSize = new PopupSize({ maximize: true });
        super.ngOnInit();
    }

    async modifyGridInfo(gridInfo: GridInfo) {
        gridInfo.filters.push(new Filter({
            field: 'type',
            operator: Operator.equal,
            value: `${this.templateType}`
        }));
    }

    async beforeAdd() {
        this.formModel.data.type = this.templateType;
    }

    // Export template.
    exportCxExcelTemplateById(rowData) {
        this._templateInstanceService.exportCxExcelTemplateById(rowData);
    }

    // Import template.
    hasImportExcelTemplate() {
        return this.templateType == TemplateTypes.cxExcel;
    }

    importExcelTemplate() {
        if (this.file.basicFileInput) {
            this.file.basicFileInput.nativeElement.click();
        }
    }

    onSelectExcelFile(evt) {
        let file = evt.files[0];
        this.file.clear();
        if (!file) {
            return;
        }

        var formData = new FormData();
        formData.append('File', file);
        this._markLoading();
        this._templateInstanceService.importExcelTemplate(formData)
            .then(rs => {
                this._unmarkLoading();
                if (rs.success) {
                    this._notifierService.showSuccess(this._translateService.instant('Import biểu mẫu excel thành công!'));
                    this._triggerProcessData();
                } else {
                    this._notifierService.showWarning(this._translateService.instant('Import biểu mẫu excel chưa thành công!'));
                }
            }, err => {
                this._unmarkLoading();
                this._notifierService.showWarning(this._translateService.instant('Lỗi network hoặc api dùng để import!'));
            });
    }


    //Test.
    exportByCodeTest() {
        if (this.templateType == TemplateTypes.word) {
            this.testWord();
        } else if (this.templateType == TemplateTypes.cxExcel) {
            this.textExcel();
        }
    }

    textExcel() {
        var data = {
            title: 'test_export_by_code',
            lst: [
                {
                    a: 1,
                    b: "b1",
                    c: true,
                    d: 2.21
                },
                {
                    a: 2,
                    b: "b1",
                    c: false,
                    d: 2.22
                },
                {
                    a: 3,
                    b: "b1",
                    c: true,
                    d: 2.23
                },
                {
                    a: 4,
                    b: "b1",
                    c: false,
                    d: 2.24
                },
            ]

        };

        var model = {
            data: JSON.stringify(data),
            code: 'TEST_EXPORT_BY_CODE',
            fileName: 'TEST_EXPORT_BY_CODE.xlsx'
        }

        this._sharedTemplateInstanceService.exportCxExcelByCode(model);
    }

    testWord() {
        var data = {
            one: 1,
            two: 2,
            three: 3,
            four: 4,
            five: 5
        };

        this._sharedTemplateInstanceService.fillTemplateByCodeAndGetPdf('TEST_EXPORT_WORD_BY_CODE', data);
    }

    exportByCodeTestWord() {
        var data = {
            one: 1,
            two: 2,
            three: 3,
            four: 4,
            five: 5
        };

        this._sharedTemplateInstanceService.fillTemplateByCode('TEST_EXPORT_WORD_BY_CODE', data, 'test_file_word');
    }
}

